import {DetailsList, IconButton} from "@fluentui/react";
import * as React from "react";
import {useEffect, useState, useContext} from "react";
import {SelectionMode} from "@fluentui/react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddDocumentType from "../Panel/DocumentType/AddDocumentType";
import EditDocumentType from "../Panel/DocumentType/EditDocumentType";
import {useOutletContext} from "react-router-dom";

function DocumentType(props) {
    const [user] = useContext(AuthContext);
    const [documentTypes, setDocumentTypes] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/document", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setDocumentTypes(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editDocumentType, setEditDocumentType] = useState(false);
    const [addDocumentType, setAddDocumentType] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addDocumentType',
                text: 'Dodaj Typ',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddDocumentType(true)
            }
        ]);
        return actions;
    }, []);

    const _manageSubscription = (item) => {
        if (item.subscribe !== null) {
            fetch(`/api/document/${item.id}/unsubscribe`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            })
        } else {
            fetch(`/api/document/${item.id}/subscribe`, {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            })
        }
        setRefresh(refresh + 1);
    }

    const columns = [
        {
            key: 'type',
            name: 'Nazwa',
            ariaLabel: 'Nazwa Typu Dokumentu',
            fieldName: 'type',
            minWidth: 210,
            isRowHeader: true,
            isResizable: true,
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 90,
            maxWidth: 90,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'MailAlert' }} styles={ {'rootChecked': {'color': 'green', 'backgroundColor': 'transparent'}, root: {color: 'red'}}} title='Subskrybuj' checked={item.subscribe !== null} onClick={() => _manageSubscription(item)}/>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditDocumentType(item)}/>
                <IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onClick={() => _deleteDocumentType(item)}/>
            </span>)
        }
    ];
    const _deleteDocumentType = (item) => {
        fetch(`/api/document/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    return (
        <AppContent title={'Dokumenty'}>
            <DetailsList items={documentTypes} columns={columns} selectionMode={SelectionMode.none}/>
            <AddDocumentType add={addDocumentType} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddDocumentType(false)} />
            <EditDocumentType add={editDocumentType} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setEditDocumentType(false)} />
        </AppContent>
    );
}

export default DocumentType;